import { Link } from "react-router-dom";

/**
 * GDPR consent checkbox used on every form that submits personal data.
 * Extracted from inline usage to eliminate any risk of parser confusion
 * with deeply-nested label > input > span > Link JSX trees.
 */
export default function ConsentCheckbox({ id, checked, onChange, text }) {
  return (
    <label htmlFor={id} className="flex items-start gap-2.5 cursor-pointer">
      <input
        id={id}
        type="checkbox"
        data-testid={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 w-4 h-4 accent-[#0055FF] cursor-pointer"
        aria-label="Agree to privacy policy"
      />
      <span className="text-xs text-[#475569] leading-relaxed">
        {text} See our <Link to="/privacy" className="text-[#0055FF] font-bold underline">Privacy Policy</Link>.
      </span>
    </label>
  );
}
